import messages from './messages.js';

const schema = {
  id: 'dayBlock',
  properties: [
    {
      id: 'time',
      type: 'time',
      label: messages.startTime,
      required: true,
    },
    {
      id: 'slotCount',
      type: 'number',
      label: messages.slotCount,
      attributes: { min: 1 },
      required: true,
    },
  ],
};

export default schema;
